module.exports = __webpack_public_path__ + "img/fastcharger-realized.788c4c94.svg";